import {
    CLEAR_FILTER_LICENCES,
    FILTER_LICENCES_PENDING, FILTER_LICENCES_SUCCESS,
    GET_LICENCES_ERROR,
    GET_LICENCES_PENDING,
    GET_LICENCES_SUCCESS
} from "./types";
import {message} from "antd";
import api from "../../api/api";
import Axios from "axios";
import {
    COMPANIES_URL_FOR_LICENCE,
    LICENCES_URL,
    SOFTWARE_PRODUCT_URL
} from "../../constants/urlConfig";
import DataType from "../../constants/DataType";
import moment from 'moment';
import {arrayContainsItemWithProperty} from "../../util/arrayUtils";
import {DATE_FORMAT} from "../../constants/dateFormat";

const getLicences = () => async (dispatch, getState) => {
    const darkMode = getState().theme.darkMode;
    try {
        dispatch({type: GET_LICENCES_PENDING});

        const [licencesResponse, companiesResponse, softwareProductsResponse] = await Axios.all([
            api.get(LICENCES_URL),
            api.get(COMPANIES_URL_FOR_LICENCE),
            api.get(SOFTWARE_PRODUCT_URL)
        ]);

        dispatch({
            type: GET_LICENCES_SUCCESS, payload:
                {
                    licences: licencesResponse.data,
                    companyOptions: companiesResponse.data,
                    softwareProductOptions: softwareProductsResponse.data
                }
        });
    } catch (e) {
        message.error({
            content: 'An error has occurred while loading licences.',
            className: darkMode && "dark-mode"
        });
        dispatch({type: GET_LICENCES_ERROR, payload: e})
    }
};

const clearLicencesFilter = () => ({
    type: CLEAR_FILTER_LICENCES
});

const filterLicences = providedFilter => async (dispatch, getState) => {
    const {licences, filterValues} = getState().licence;

    const filterExists = arrayContainsItemWithProperty(filterValues, 'key', providedFilter.key);
    let newFilterValues = filterValues;
    if (filterExists) {
        newFilterValues = filterValues.map(p =>
            p.key === providedFilter.key
                ? { ...providedFilter }
                : p
        );
    } else {
        newFilterValues.push(providedFilter);
    }

    dispatch({type: FILTER_LICENCES_PENDING, payload: newFilterValues});
    const filteredLicences = licences.filter(item => {

        let shouldShowItem = true;
        newFilterValues.forEach(fMap => {
            console.log(fMap)
            if (fMap.key === 'company') {
                if (fMap.value && item.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.companyResponse.id !== fMap.value)
                    shouldShowItem = false;
            } else if (fMap.key === 'code') {
                if (fMap.value && item.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.code.indexOf(fMap.value) === -1)
                    shouldShowItem = false;
            } else if (fMap.key === 'softwareProduct') {
                if (fMap.value && item.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.softwareProductResponse.id !== fMap.value)
                    shouldShowItem = false;
            } else if (fMap.type === DataType.DATE || fMap.type === DataType.DATE_TIME) {
                if (fMap.value.startsWith('>') || fMap.value.startsWith('<')) {
                    let dateValue = fMap.value.substr(1);

                    const re = new RegExp(/^\d{2}[./-//]\d{2}[./-///]\d{4}([./-///]?)$/);

                    if (re.test(dateValue.trim())) {
                        const filterValue = moment(dateValue, DATE_FORMAT);
                        const fieldValue = moment(item.issueDate);

                        if (fMap.value.startsWith(">")) {
                            shouldShowItem = fieldValue.unix() - filterValue.unix() > 0;

                        }

                        if (fMap.value.startsWith("<")) {
                            shouldShowItem = filterValue.unix() - fieldValue.unix() > 0;
                        }

                    }
                }
            } else if (fMap.type === DataType.SELECT || fMap.type === DataType.MULTI_SELECT) {
                if (fMap.value && item[fMap.key] !== fMap.value)
                    shouldShowItem = false;
            } else if (item[fMap.key].toLowerCase().indexOf(fMap.value.toLowerCase()) === -1)
                shouldShowItem = false;
        });
        if (shouldShowItem)
            return true
    });
    dispatch({type: FILTER_LICENCES_SUCCESS, payload: filteredLicences});
};

export {getLicences, filterLicences, clearLicencesFilter}